import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { goodsManageListNewData} from './data'
import { normaluseredit,getuserlist,normaluserlist} from "@/servers/goodsManageApi";
import {setPageNewItem, urlFormat} from "@/utils";
import './index.scss'
import {message} from "antd";
import {compose} from "redux";
import {withRouter} from "react-router-dom";

@CBaseComponent
class StoreManageListNew extends Component{

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.checkModbile = this.checkModbile.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }


  state = {
    data: goodsManageListNewData
  }

  onChange(data){
    this.setState({
      data: setPageNewItem(this.state.data, data.data.id, 'value', data.value)
    })
  }

  onCancel(){
    this.props.history.push({
      pathname: '/person/userProvince',
    });
  }

  //JS使用正则表达式校验电话号码
   checkModbile(mobile) {
    var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
    var result = re.test(mobile);
    if(!result) {
      return false;//若手机号码格式不正确则返回false
    }
    return true;
  }

  //JS校验邮箱
   IsEmail(str) {
    var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
    return  reg.test(str);
  }



  onSubmit(data){
    if (data.status){
      if (data.data.password.length<6) {
        message.error('密码不能小于6位');
        return false
      }
      if (!this.checkModbile(data.data.mobile)) {
        message.error('输入的手机号不正确');
        return false
      }
      if (data.data.email !=='' && !this.IsEmail(data.data.email)) {
        message.error('输入的Email不正确');
        return false
      }
    }
    let method = normaluseredit;
    if(this.props.history!==undefined &&  urlFormat(this.props.history.location.search).query.type === 'edit'){
      data.data.id = urlFormat(this.props.history.location.search).query.id;
    } else {
      data.data.id = ''
    }

    method(data.data).then(res=>{
      if (res.statecode === 0) {
        if(this.getUrlParams(window.location.href).type === 'edit'){
          message.success('编辑成功');
        }
        else {
          message.success('添加成功');
        }
        this.props.history.push({
          pathname: '/person/userProvince',
        })
      }else {
        if(this.getUrlParams(window.location.href).type === 'edit'){
          message.error('编辑失败');
        }
        else {
          message.error('添加失败');
        }
      }
    }).catch(err=>{

    });
  }

  getUser(){
    getuserlist({id:""}).then(res=>{
      let data =JSON.parse(JSON.stringify(res.records[0].datalist))
      const adddata = this.state.data
      adddata[0].data[14].options = data
      this.setState({
        data:adddata
      });
    }).catch(err=>{
    })
  }

  getUrlParams(url) {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1]
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&')
    for(let i = 0,len = paramsArr.length;i < len;i++){
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=')
      obj[arr[0]] = arr[1];
    }
    return obj
  }

  getListData(){
    let getData = {
      id: ''
    };
    this.setState({
      loading: true
    });
    normaluserlist(getData).then(res=>{
      let data =JSON.parse(JSON.stringify(res.records[0].workunitlist))
      goodsManageListNewData[0].data[5].options = data
      this.setState({
        data:goodsManageListNewData
      })
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  componentWillMount(){
    this.getListData()
    this.getUser()
    if(this.getUrlParams(window.location.href).type === 'edit'){
      let params = this.state.data
      const edit = JSON.parse(sessionStorage.getItem('countryuser'))
      params[0].data[0].value = edit.realname
      params[0].data[1].value = edit.name
      params[0].data[3].value = edit.password.toString() === '1'? '******':''
      params[0].data[2].value = edit.mobile
      params[0].data[4].value = edit.email
      params[0].data[5].value = edit.workunit
      params[0].title = '编辑用户'
      this.setState({
        data:params
      })
    } else {
      let params = this.state.data
      params[0].data[0].value = ''
      params[0].data[1].value = ''
      params[0].data[3].value = ''
      params[0].data[2].value = ''
      params[0].data[4].value = ''
      params[0].data[5].value =''
      params[0].title = '添加用户'
      this.setState({
        data:params
      })
    }
  }

  render(){
    return (
      <div className='store-manage-list-new'>
        <CPageNew data={this.state.data}
                  onChange={this.onChange}
                  onSubmit={this.onSubmit}
                  onSearch={this.onSearch}
                  onCancel={this.onCancel}
        />
      </div>
    )
  }
}
export default compose(withRouter)(StoreManageListNew);
